import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  NewspaperIcon,
  ArrowDownTrayIcon,
  CalendarIcon,
} from "@heroicons/react/24/outline";
import { motion, AnimatePresence } from "framer-motion";
import { API_BASE } from "../../config";

const monthNames = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December",
];

const EditorialAnalysis = () => {
  const [groupedEditorials, setGroupedEditorials] = useState({});
  const [expandedMonth, setExpandedMonth] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userToken, setUserToken] =
  useState(

    JSON.parse(
      localStorage.getItem("user")
    )?.token || ""
  );

  // =========================
// Sync Updated Token
// =========================

useEffect(() => {

  const syncUser = () => {

    const updatedUser =
      JSON.parse(

        localStorage.getItem(
          "user"
        )
      );

    setUserToken(
      updatedUser?.token || ""
    );
  };



  window.addEventListener(
    "userUpdated",
    syncUser
  );



  return () => {

    window.removeEventListener(
      "userUpdated",
      syncUser
    );
  };

}, []);

  useEffect(() => {
    const fetchEditorials = async () => {
      try {
        const token = userToken;

        const res = await axios.get(`${API_BASE}/api/user/editorials`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const sorted = res.data.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );

        const grouped = {};
        sorted.forEach((ed) => {
          const date = new Date(ed.date);
          const year = date.getFullYear();
          const month = monthNames[date.getMonth()];

          if (!grouped[year]) grouped[year] = {};
          if (!grouped[year][month]) grouped[year][month] = [];

          grouped[year][month].push(ed);
        });

        setGroupedEditorials(grouped);
      } catch (err) {
        console.error("❌ Failed to fetch editorials:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEditorials();
  }, []);

  // =========================
// Track Analytics
// =========================
const trackEditorialActivity =
  async (type) => {

    try {

      const token =
  userToken;

      if (!token) return;

      await axios.post(

        `${API_BASE}/api/user/editorials/track-view`,

        {
          type,
        },

        {
          headers: {
            Authorization:
              `Bearer ${token}`,
          },
        }
      );

    } catch (err) {

      console.error(
        "Editorial analytics failed",
        err
      );
    }
  };

  const handleDownload = (url, filename) => {
    if (!url) return;
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="space-y-8">
      {/* Header */}
      <motion.h2
        className="text-3xl font-bold text-purple-700 flex items-center gap-3 dark:text-purple-400"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <NewspaperIcon className="w-8 h-8 text-purple-500" />
        The Hindu Analysis
      </motion.h2>

      {loading ? (
        <p className="text-gray-500 text-center">Loading editorials...</p>
      ) : (
        Object.keys(groupedEditorials)
          .sort((a, b) => b - a)
          .map((year) => (
            <div key={year} className="space-y-6">
              <h3 className="text-2xl font-semibold border-b pb-2 text-gray-900 dark:text-gray-100 border-purple-300 dark:border-purple-700">
                {year}
              </h3>

              {/* Month Grid */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {Object.keys(groupedEditorials[year]).map((month) => (
                  <button
                    key={month}
                    onClick={() =>
                      setExpandedMonth(
                        expandedMonth === `${year}-${month}`
                          ? null
                          : `${year}-${month}`
                      )
                    }
                    className={`p-4 rounded-xl border transition-all
  ${
    expandedMonth === `${year}-${month}`
      ? "bg-purple-600 text-white border-purple-700"
      : "bg-white dark:bg-gray-800 text-purple-700 dark:text-purple-300 border-purple-300 dark:border-purple-700 hover:bg-purple-50 dark:hover:bg-gray-700"
  }`}
                  >
                    <CalendarIcon className="w-6 h-6 mx-auto" />
                    <p>{month}</p>
                  </button>
                ))}
              </div>

              {/* Expanded */}
              <AnimatePresence>
                {Object.keys(groupedEditorials[year]).map((month) => {
                  const isOpen = expandedMonth === `${year}-${month}`;

                  return (
                    isOpen && (
                      <motion.div
                        key={month}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="space-y-4"
                      >
                        <h4 className="text-xl font-semibold">
                          {month} {year}
                        </h4>

                        <div className="grid md:grid-cols-2 gap-6">
                          {groupedEditorials[year][month].map((item) => (
                            <div
                              key={item._id}
                              className="bg-white border rounded-xl p-5 shadow"
                            >
                              {/* Date */}
                              <h3 className="font-semibold mb-2">
                                {new Date(item.date).toLocaleDateString()}
                              </h3>

                              {/* 🎥 VIDEO */}
{item.youtubeVideoId && (
  <div className="mt-5">

    {/* Header */}
    <div className="flex items-center justify-between mb-4">

      <div className="flex items-center gap-2">
        <span className="text-purple-600 font-semibold flex items-center gap-2">
          🎥 The Hindu Analysis
        </span>
      </div>

      <div className="bg-purple-100 text-purple-700 text-xs font-bold px-3 py-1 rounded-full">
        UPSC DAILY
      </div>

    </div>


    {/* Main Layout */}
    <div className="space-y-5">

      {/* ================= THUMBNAIL ================= */}
      <div
        onClick={() => {

          trackEditorialActivity("editorialVideo");

          window.open(
            `https://www.youtube.com/watch?v=${item.youtubeVideoId}`,
            "_blank"
          );
        }}
        className="
relative
rounded-[28px]
overflow-hidden
cursor-pointer
group
shadow-xl
bg-black
w-full
"
      >

        {/* Thumbnail */}
        <img
          src={`https://img.youtube.com/vi/${item.youtubeVideoId}/maxresdefault.jpg`}
          alt="YouTube Thumbnail"
          className="
w-full
aspect-video
object-contain
bg-black
transition-transform
duration-700
group-hover:scale-[1.02]
"
          onError={(e) => {
            e.target.src = `https://img.youtube.com/vi/${item.youtubeVideoId}/hqdefault.jpg`;
          }}
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />

        {/* Play Button */}
        <div className="absolute inset-0 flex items-center justify-center">

          <div className="
relative
rounded-[28px]
overflow-hidden
cursor-pointer
group
shadow-xl
bg-black
min-h-[240px]
">

            {/* Pulse */}
            <div className="absolute inset-0 rounded-full bg-red-500 animate-ping opacity-20" />

            {/* Main */}
            <div className="relative bg-red-600 group-hover:bg-red-500 transition-all duration-300 group-hover:scale-110 rounded-full p-6 shadow-2xl">

              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="white"
                viewBox="0 0 24 24"
                className="w-12 h-12"
              >
                <path d="M8 5v14l11-7z" />
              </svg>

            </div>

          </div>

        </div>

        {/* Bottom Content */}
        <div className="absolute bottom-0 left-0 right-0 p-5">

          <div className="flex items-end justify-between">

            <div>

              <h2 className="text-white text-3xl font-black leading-tight">
                The Hindu Analysis
              </h2>

              <p className="text-gray-200 mt-1 text-sm">
                Editorial Discussion & UPSC Insights
              </p>

            </div>

            {/* Youtube Badge */}
            <div className="hidden sm:flex bg-red-600 text-white text-xs font-bold px-3 py-2 rounded-full shadow-lg">
              YOUTUBE
            </div>

          </div>

        </div>

      </div>

      {/* ================= SIDE PANEL ================= */}
      <div className="flex flex-col gap-4">

        {/* Watch Button */}
        <div className="hidden">
<button
          onClick={() => {

            trackEditorialActivity("editorialVideo");

            window.open(
              `https://www.youtube.com/watch?v=${item.youtubeVideoId}`,
              "_blank"
            );
          }}
          className="group flex-1 bg-gradient-to-br from-red-500 to-red-600 hover:from-red-400 hover:to-red-500 text-white rounded-[28px] p-5 shadow-xl transition-all duration-300 hover:-translate-y-1"
        >

          {/* Top */}
          <div className="flex items-center justify-between mb-5">

            <div className="bg-white/20 p-3 rounded-2xl backdrop-blur-sm">

              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="white"
                viewBox="0 0 24 24"
                className="w-7 h-7"
              >
                <path d="M21.8 8s-.2-1.4-.8-2c-.8-.8-1.7-.8-2.1-.9C15.9 5 12 5 12 5h0s-3.9 0-6.9.1c-.4 0-1.3.1-2.1.9C2.4 6.6 2.2 8 2.2 8S2 9.6 2 11.3v1.4C2 14.4 2.2 16 2.2 16s.2 1.4.8 2c.8.8 1.9.8 2.4.9 1.7.2 6.6.1 6.6.1s3.9 0 6.9-.1c.4 0 1.3-.1 2.1-.9.6-.6.8-2 .8-2s.2-1.6.2-3.3v-1.4C22 9.6 21.8 8 21.8 8zM9.8 14.5v-5l4.8 2.5-4.8 2.5z" />
              </svg>

            </div>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-5 h-5 group-hover:translate-x-1 transition"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H18m0 0v4.5M18 6l-7.5 7.5"
              />
            </svg>

          </div>

          {/* Content */}
          <div className="text-left">

            <h3 className="text-3xl font-black leading-tight">
              Watch Analysis
            </h3>

            <p className="mt-3 text-red-100 text-sm leading-relaxed">
              Full Editorial Breakdown & Current Affairs Discussion
            </p>

          </div>

        </button>
        </div>        

      </div>

    </div>

  </div>
)}
{/* ================= PDFs ================= */}
{(item.editorialPdfUrl || item.prelimsNotesPdfUrl) && (

<div className="mt-6 grid md:grid-cols-2 gap-4">

{/* Editorial PDF */}

{item.editorialPdfUrl && (

<>

<a
href={item.editorialPdfUrl}
target="_blank"
rel="noopener noreferrer"

onClick={()=>
trackEditorialActivity(
"editorial"
)
}

className="
bg-gradient-to-r
from-purple-600
to-indigo-600
hover:from-purple-500
hover:to-indigo-500
text-white
rounded-[22px]
py-4
px-5
flex
items-center
justify-center
font-bold
shadow-lg
"
>

📰 Read Editorials

</a>

<button
onClick={()=>

handleDownload(

item.editorialPdfUrl,

`Editorial-${
new Date(
item.date
)
.toISOString()
.split("T")[0]
}.pdf`

)

}

className="
bg-white
dark:bg-gray-800
dark:text-white
border
rounded-[22px]
py-4
px-5
w-full
min-h-[72px]
"
>

⬇ Download Editorials Note

</button>

</>

)}



{/* Prelims Notes */}

{item.prelimsNotesPdfUrl && (

<>

<a
href={
item.prelimsNotesPdfUrl
}

target="_blank"

rel="noopener noreferrer"

className="
bg-gradient-to-r
from-green-600
to-emerald-600
hover:from-green-500
hover:to-emerald-500
text-white
rounded-[22px]
py-4
px-5
flex
justify-center
font-bold
shadow-lg
"
>

📘 Read Prelims Note

</a>

<button
onClick={()=>

handleDownload(

item.prelimsNotesPdfUrl,

`Prelims-${
new Date(
item.date
)
.toISOString()
.split("T")[0]
}.pdf`

)

}

className="
bg-white
dark:bg-gray-800
dark:text-white
border
rounded-[22px]
py-4
px-5
w-full
min-h-[72px]
"
>

⬇ Download Prelims Note

</button>

</>

)}

</div>
)}
                            </div>
                          ))}
                        </div>
                      </motion.div>
                    )
                  );
                })}
              </AnimatePresence>
            </div>
          ))
      )}
    </div>
  );
};

export default EditorialAnalysis;